export const LOGIN_USER_LOADING = "user/login/loading";
export const LOGIN_USER_SUCCESS = "user/login/success";
export const LOGIN_USER_FAILURE = "user/login/failure";

export const OTP_USER_LOADING = "user/otp/loading";
export const OTP_USER_SUCCESS = "user/otp/success";
export const OTP_USER_FAILURE = "user/otp/failure";

export const LOGOUT_USER_LOADING = "user/logout/loading";
export const LOGOUT_USER_SUCCESS = "user/logout/success";
export const LOGOUT_USER_FAILURE = "user/logout/failure";

export const REFRESH_TOKEN_REQUEST = "REFRESH_TOKEN_REQUEST";
export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS";
export const REFRESH_TOKEN_FAILURE = "REFRESH_TOKEN_FAILURE";
